import classNames from 'classnames/bind';
import styles from './Complete.module.scss';
import Card, { CardHeader } from '../../../components/Card';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import { resetEnrollment } from '../../../state/enrollment/enrollmentActions';

const cx = classNames.bind(styles);

interface CompleteProps {
  resetEnrollment: typeof resetEnrollment;
}

const Complete = (props: CompleteProps) => {
  const { resetEnrollment } = props;

  const navigate = useNavigate();

  const startAnotherEnrollment = () => {
    resetEnrollment();
    navigate('/');
  };

  const viewNextSteps = () =>
    window.open(
      'https://dfinfilermanagementsupport.dfinsolutions.com/hc/en-us/articles/30603828097943',
      '_blank'
    );

  return (
    <div className={cx('complete')}>
      <Card className={cx('complete__card')}>
        <CardHeader
          title="Congratulations you're enrolled in EDGAR Next!"
          classes={{
            title: cx('complete__title'),
            logo: cx('complete__logo'),
          }}
        />
        <div className={cx('complete__body')}>
          <p className={cx('complete__paragraph')}>
            You are now enrolled in EDGAR Next. To understand what happens next,
            including instructions for our clients who chose to complete the
            delegation process on their own, please view our next steps article
            by clicking the link below.
          </p>
          <p className={cx('complete__paragraph')}>
            For any immediate questions or concerns, please contact us via email
            at{' '}
            <a
              className={cx('complete__mailto')}
              href="mailto:edgarnext@dfinsolutions.com"
            >
              edgarnext@dfinsolutions.com
            </a>
          </p>
        </div>
        <div className={cx('complete__footer')}>
          <Button onClick={viewNextSteps} className={cx('complete__button')}>
            View next steps
          </Button>
          <Button
            onClick={startAnotherEnrollment}
            className={cx('complete__button')}
          >
            Start another Enrollment
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default Complete;
